import { render, staticRenderFns } from "./GrupoEmpresarial.vue?vue&type=template&id=aabd59aa&"
import script from "./GrupoEmpresarial.vue?vue&type=script&lang=js&"
export * from "./GrupoEmpresarial.vue?vue&type=script&lang=js&"
import style0 from "./GrupoEmpresarial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports